<template>
  <div class="rr-grid" :class="classes"><slot></slot></div>
</template>

<script>
export default {
  name: 'RrRow',
  props: {
    /**
     * Вертикальное выравнивание
     */
    align: {
      type: String,
      validator(value) {
        return ['', 'start', 'center', 'end', 'baseline'].indexOf(value) !== -1;
      },
    },
    /**
     * Горизонтальное выравнивание
     */
    justify: {
      type: String,
      validator(value) {
        return ['', 'start', 'center', 'end', 'space-around', 'space-between'].indexOf(value) !== -1;
      },
    },
    /**
     * Добавляет вертикальные отступы
     */
    verticalGutters: {
      type: Boolean,
      default: false,
    },
    /**
     * Убирает горизонтальные отступы между колонками
     */
    noGutters: {
      type: Boolean,
      default: false,
    },
    /**
     * Запрещает перенос колонок на следующую строку
     */
    noWrap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      const classes = [];
      const modifiers = [
        this.align && `align-${this.align}`,
        this.justify && `justify-${this.justify}`,
        this.noGutters && 'no-gutters',
        this.verticalGutters && 'v-gutters',
        this.guttersSize && `gutters-${this.guttersSize}`,
        this.noWrap && 'nowrap',
      ];

      modifiers.forEach((modifier) => {
        if (modifier) {
          classes.push(`rr-grid_${modifier}`);
        }
      });

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./Row";
</style>
